import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageShell } from "@/components/PageShell";

export const Route = createFileRoute("/ask-arif")({
  component: AskArifLayout,
});

function AskArifLayout() {
  return (
    <PageShell>
      <Outlet />
    </PageShell>
  );
}
